import { Directive, HostListener, Input } from "@angular/core";
import { CeloFileUploader } from "./celo-file-uploader";

/** Adds files chosen via a native <input type="file"> to the bound uploader. */
@Directive({
  selector: "[celoFileSelect]",
  standalone: false,
})
export class CeloFileSelectDirective {
  @Input() uploader!: CeloFileUploader;

  @HostListener("change", ["$event.target"])
  onChange(target: EventTarget | null): void {
    const input = target as HTMLInputElement | null;
    if (!this.uploader || !input?.files?.length) {
      return;
    }
    this.uploader.addFiles(input.files);
    // Reset so selecting the same file again re-triggers change.
    input.value = "";
  }
}
